import { render, staticRenderFns } from "./SectionAForm.vue?vue&type=template&id=9b202524&scoped=true&"
import script from "./SectionAForm.vue?vue&type=script&lang=js&"
export * from "./SectionAForm.vue?vue&type=script&lang=js&"
import style0 from "./SectionAForm.vue?vue&type=style&index=0&id=9b202524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b202524",
  null
  
)

export default component.exports